import { render } from "./IsUfPay.vue?vue&type=template&id=61cb5ea2&scoped=true"
import script from "./IsUfPay.vue?vue&type=script&lang=js"
export * from "./IsUfPay.vue?vue&type=script&lang=js"

import "./IsUfPay.vue?vue&type=style&index=0&id=61cb5ea2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61cb5ea2"]])

export default __exports__